var map = {
	"./img1.png": "dy/b",
	"./img2.png": "6fB0",
	"./img3.png": "/zZA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FAK5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feature ^\.\/img.*\.png$
// module id = FAK5
// module chunks = 1